import React from 'react';
import { Bar as BarElement } from '@vx/shape';

export const Bar = ({ color, isHovered, ...restProps }) => (
  <BarElement fill={isHovered ? 'red' : color} {...restProps} />
);
